import React, { useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { resetPassword } from '../api'
import { setSession } from '../session'
import Button from '../components/Button'
import Input from '../components/Input'
import { ErrorAlert } from '../components/Alert'
import { useDocumentTitle } from '../components/PublicLayout'
import AuthHeader from '../components/AuthHeader'

export default function ResetPassword() {
  useDocumentTitle('Set a new password')
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const token = params.get('token') || ''

  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    if (password.length < 8) {
      setError('Password must be at least 8 characters.')
      return
    }
    if (password !== confirm) {
      setError('Passwords do not match.')
      return
    }
    setLoading(true)
    try {
      // On success the backend returns a fresh token, logging the user straight
      // in — store the session and go to the dashboard.
      const data = await resetPassword(token, password)
      setSession(data)
      navigate('/dashboard')
    } catch (err) {
      setError(err.message || 'Could not reset your password. The link may have expired.')
    } finally {
      setLoading(false)
    }
  }

  if (!token) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="w-full max-w-sm bg-white rounded-2xl shadow-sm border border-gray-200 p-8 text-center">
          <h1 className="text-xl font-bold text-gray-900">Invalid reset link</h1>
          <p className="mt-2 text-sm text-gray-600">
            This password-reset link is missing its token. Request a new one.
          </p>
          <div className="mt-6">
            <Button onClick={() => navigate('/forgot-password')} className="w-full">
              Request a new link
            </Button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <AuthHeader subtitle="Choose a new password" />

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
          <form onSubmit={handleSubmit} className="space-y-4">
            <ErrorAlert message={error} />
            <Input
              label="New password"
              type="password"
              required
              autoComplete="new-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              hint="At least 8 characters."
            />
            <Input
              label="Confirm new password"
              type="password"
              required
              autoComplete="new-password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              placeholder="••••••••"
            />
            <Button type="submit" loading={loading} className="w-full">
              Set new password
            </Button>
          </form>
        </div>

        <p className="text-center text-xs text-gray-500 mt-6">
          <Link to="/signin" className="text-brand-500 hover:underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}
